import React, { Component } from "react";
import { View, KeyboardAvoidingView, Platform } from "react-native";
import * as SecureStore from "../../components_v2/DeviceAsyncStorage";
import * as AppActions from "../../actions/AppActions";
import * as CONSTS from "../../../assets/consts";
import { connect } from "react-redux";
import ServerList from "../../components_v2/Servers/ServerList";
import { getServerInfo } from "../../util";
import checkIPAddress from "../../hooks/checkIPAddress";
const axios = require("axios").default;

class ServersListScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      serverIP: "",
      selectedServerInfo: undefined,
      showButtons: true,
      scanning: false,
    };

    this.httpClient = axios.create();
    this.httpClient.defaults.timeout = 100;
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("user_profile.serversList"),
  });
  componentDidMount() {}

  goBack = (serverInfo = null, buildingId = null, addressConnected = "") => {
    if (serverInfo) {
      try {
        this.props.navigation.goBack();
        // callback
        typeof this.props.navigation.state.params.onGoBack == "function" &&
          this.props.navigation.state.params.onGoBack(
            serverInfo,
            buildingId,
            addressConnected
          );
      } catch (e) {}
    } else {
      this.props.navigation.goBack();
    }
  };
  navigateToLogin = async (address) => {
    // this.props.updateServerUrl(address);
    await SecureStore.deleteItemAsync(CONSTS.ACCESS_TOKEN);
    setTimeout(() => {
      this.props.reconnect(address);
      this.props.navigation.replace("Login");
    }, 1000);
  };
  updateDataAndForceInit = async (
    serverInfo,
    building = null,
    addressConnected = ""
  ) => {
    await SecureStore.setItemAsync(CONSTS.ACCESS_TOKEN, serverInfo.accessToken);

    // this.goBack();
    // this.props.reconnect(serverInfo.publicAddress);
    this.props.updateCurrentServer(serverInfo);
    if (building) {
      this.props.updateCurrentBuilding(building);
      setTimeout(() => {
        this.goBack(serverInfo, building.buildingId, addressConnected);
      }, 1000);
    } else {
      setTimeout(() => {
        this.goBack(serverInfo, null, addressConnected);
      }, 1000);
    }
  };
  handleOnServerChange = async (serverInfo, addressConnected) => {
    let { accessToken, publicAddress, serverId } = serverInfo;
    if (serverInfo) {
      if (accessToken) {
        const findBuilding = this.props.AppReducer.buildings.find(
          (building) =>
            building.serverId === serverId ||
            building.cloudServerId === serverId
        );
        await SecureStore.setItemAsync(
          CONSTS.SERVER_URL,
          addressConnected || serverInfo.publicAddress
        );
        // === check localAddress ===
        const _checkIPAddress = checkIPAddress(publicAddress);
        if (_checkIPAddress) {
          let httpClient = axios.create();
          httpClient.defaults.timeout = 2000;
          if (findBuilding) {
            const _checkConnectionServerInfo = await getServerInfo(
              httpClient,
              publicAddress,
              checkIPAddress ? findBuilding.buildingId : ""
            );
            if (
              _checkConnectionServerInfo &&
              _checkConnectionServerInfo.buildingId === findBuilding.buildingId
            ) {
              this.updateDataAndForceInit(
                serverInfo,
                findBuilding,
                addressConnected
              );
            } else if (_checkConnectionServerInfo) {
              this.updateDataAndForceInit(serverInfo, null, addressConnected);
            }
          } else {
            this.navigateToLogin(publicAddress);
          }
        } else {
          // === check connection ===
          let httpClient = axios.create();
          httpClient.defaults.timeout = 3000;
          // === check public address ===
          const _checkConnectionServerInfo = await getServerInfo(
            httpClient,
            publicAddress
          );
          if (_checkConnectionServerInfo && findBuilding) {
            this.updateDataAndForceInit(
              serverInfo,
              findBuilding,
              addressConnected
            );
          } else if (_checkConnectionServerInfo) {
            this.updateDataAndForceInit(serverInfo, null, addressConnected);
          } else {
            this.navigateToLogin(publicAddress);
          }
        }
      } else {
        this.navigateToLogin(publicAddress);
      }
    }
  };
  render() {
    return (
      <KeyboardAvoidingView
        behavior="height"
        style={{ flex: 1 }}
        enabled={true}
        keyboardVerticalOffset={60}
      >
        <View style={{ flex: 1 }}>
          <ServerList
            onSelect={(serverInfo, addressConnected) => {
              this.handleOnServerChange(serverInfo, addressConnected);
            }}
            onBack={() => {
              this.goBack();
            }}
          />
          {/* <ProfilePicker
            showConfirm={false}
            onItemSelect={(selectedServerInfo) =>
              this.setState({ selectedServerInfo })
            }
            onStartAdd={() => this.setState({ showButtons: false })}
            onEndAdd={() => this.setState({ showButtons: true })}
            onScanning={(scan) => this.setState({ scanning: scan })}
            onActiveProfileDelete={() => {
              SecureStore.deleteItemAsync(CONSTS.SERVER_URL);
              this.props.logout();
            }}
          /> */}
        </View>
      </KeyboardAvoidingView>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    AppReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateServerUrl: (serverUrl) => {
      dispatch(AppActions.updateServerUrl(serverUrl));
    },
    updateCurrentServer: (serverInfo) => {
      dispatch(AppActions.updateCurrentServer(serverInfo));
    },
    updateCurrentBuilding: (currentBuilding) => {
      dispatch(AppActions.updateCurrentBuilding(currentBuilding));
    },
    forceInit: (accessToken) => dispatch(AppActions.ForceInit(accessToken)),
    // clearDevices: () => dispatch(DeviceActions.ClearAll()),
    // clearAreas: () => dispatch(AreaActions.ClearAll()),
    reconnect: (newServerUrl) =>
      dispatch(AppActions.ResetConnection(newServerUrl)),
    logout: () => dispatch(AppActions.LogOut()),
    addServer: (serverInfo) => dispatch(AppActions.addServer(serverInfo)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServersListScreen);
